import { HttpClient } from '@angular/common/http';
import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { SocketEventTypes } from '@app/enums';
import { BenefitInvoice, BenefitInvoiceStatusType } from '@app/models/benefits/benefit-invoice.model';
import { AuthService, NotifyService, SocketService } from '@app/services';
import { BenefitInvoiceStatusDisplayOptions } from '@app/types/translatables/benefit-invoice-status-display.options';
import { environment } from '@env/environment';
import { BadgeType } from '@humi-design-library/components/Badge/types';
import { Subscription } from 'rxjs';

interface BenefitInvoiceSyncUpdatePayload {
    id: number;
    status: BenefitInvoiceStatusType;
}

@Component({
    templateUrl: './benefit-invoice-show.template.html',
    styleUrls: ['./benefit-invoice-show.style.scss'],
})
export class BenefitInvoiceShowView implements OnInit {
    benefitInvoice: BenefitInvoice;
    benefitInvoiceStatusDisplayOptions = BenefitInvoiceStatusDisplayOptions;

    isLoading = false;
    syncType: BadgeType = 'default';
    status: BenefitInvoiceStatusType = 'unsynced';

    private socketSubscription = Subscription.EMPTY;

    constructor(
        public readonly route: ActivatedRoute,
        protected auth: AuthService,
        protected notify: NotifyService,
        private http: HttpClient,
        private socketService: SocketService,
        private destroyRef: DestroyRef
    ) {
        this.benefitInvoice = this.route.snapshot.data.models.get('benefitInvoice');

        this.status = this.benefitInvoice.status;
        this.syncType = this.benefitInvoice.statusBadgeType;
    }

    ngOnInit(): void {
        if (this.benefitInvoice.status === 'syncing') {
            this.subscribeToSyncChanges();
        }
    }

    sync(): void {
        const endpoint = `${environment.api}/v2/benefitManagement/syncInvoiceToPayrollBenefit`;
        const payload = {
            benefitInvoiceId: this.benefitInvoice.id,
        };

        this.subscribeToSyncChanges();

        this.http.post(endpoint, payload).toPromise();
    }

    private subscribeToSyncChanges(): void {
        if (!this.socketSubscription.closed) {
            return;
        }

        this.socketSubscription = this.socketService
            .getCompanyChannel([SocketEventTypes.benefitsInvoiceSyncUpdate])
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(async (payload: BenefitInvoiceSyncUpdatePayload) => {
                this.benefitInvoice.status = payload.status;
                this.status = payload.status;
                this.syncType = this.benefitInvoice.statusBadgeType;

                if (payload.status === 'synced' || payload.status === 'failed') {
                    this.socketSubscription.unsubscribe();
                }
            });
    }
}
